import Environment from '../../Environment';
import stages from '../stages';
import MockSplit from '../../MockSplit';
import Region from '../../../constants/region';

const prod = new Environment({
    name: stages.PRODUCTION,
    regions: [Region.IMP, Region.UDA],
});

const demo = new Environment({
    name: stages.DEMO,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const staging = new Environment({
    name: stages.STAGING,
    regions: [Region.UDA],
});

const local = new Environment({
    name: stages.LOCAL,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const dev = new Environment({
    name: stages.DEV,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const can_access_processed_fluids_receiving = new MockSplit({
    name: 'can_access_processed_fluids_receiving',
    environments: [local, dev, staging, demo, prod],
});

export default can_access_processed_fluids_receiving;
